module.exports = __webpack_public_path__ + "img/logo.60112eb7.png";